import axios from "axios";
import CommonUtil from "../util/CommonUtils";
import { jwtDecode } from "jwt-decode";

const axiosHelper = (headers, apiType) => {

  const baseURL = apiType === 'web'
    ? process.env.REACT_APP_SERVER_URL
    : process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1");

  let req = axios.create({
    baseURL: baseURL,
    headers: headers,
  });

  req.interceptors.request.use(function (request) {
    localStorage.setItem("isLoading", true);
    window.dispatchEvent(new Event("storage"));
    return request;
  });

  req.interceptors.response.use(
    function (response) {
      if (response.status === 200 && response.data?.code === "ERROR") {
        var checkPath = localStorage.getItem("isControlPanel");
        CommonUtil.expireUserSession();
        localStorage.setItem('login_session', "expired");
        if (!CommonUtil.isEmptyString(checkPath)) {
          window.location = "/control-panel";
        } else {
          window.location = "/";
        }

      }
      localStorage.setItem("isLoading", false);
      window.dispatchEvent(new Event("storage"));
      return response;
    },
    function (error) {
      if (
        401 === error.response?.status &&
        window.location.pathname !== "/error"
      ) {
        // window.location = "/error";
        localStorage.setItem('login_session', "expired");
        CommonUtil.expireUserSession();
      }
    }
  );

  return req;
};

const securedAxiosApi = () => {

  return axiosHelper({
    "Content-type": "application/json",
    Authorization: localStorage.getItem("token"),
    "accept-language": localStorage.getItem("i18nextLng"),
    timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }, "api");
};

const securedAxios = () => {
  return axiosHelper({
    "Content-type": "application/json",
    Authorization: localStorage.getItem("token"),
    "accept-language": localStorage.getItem("i18nextLng"),
    timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }, "web");
};

const unsecuredAxios = () => {
  return axiosHelper({
    "Content-type": "application/json",
    "accept-language": localStorage.getItem("i18nextLng"),
    timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }, "web");
};

const unsecuredAxiosApi = () => {
  return axiosHelper({
    "Content-type": "application/json",
    "accept-language": localStorage.getItem("i18nextLng"),
    timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }, "api");
};

const api = {
  axiosHelper,
  securedAxios,
  unsecuredAxios,
  securedAxiosApi,
  unsecuredAxiosApi,
};

export default api;

let isRefreshing = false;
let refreshPromise = null;

export const callRefreshToken = async (returnValue) => {
  const refreshToken = CommonUtil.getCookie("refresh_token");
  const access_token = CommonUtil.getCookie("token");
  const lastCallTime = CommonUtil.getCookie("last_call");
   let user = CommonUtil.decodeToken();

  const currentTime = Math.floor(Date.now() / 1000);

  if (refreshToken && access_token) {
    const decoded = jwtDecode(access_token);

    if (decoded.exp > currentTime && lastCallTime) {
      return true;
    }

    if (isRefreshing && refreshPromise) {
      // Wait for the current refresh to complete
      return refreshPromise;
    }

    // Start refresh
    isRefreshing = true;
    CommonUtil.setCookie("last_call", new Date(), 0.01041667); // ~15 min

    refreshPromise = (async () => {
      const payload = {
        refresh_token: refreshToken,
        access_token: access_token,
        userId: user?.id || "",
        companyId: user?.companyId || "",
      };

      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      };

      try {
        const fetchResponse = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/validating`,
          settings
        );
        const res = await fetchResponse.json();
        isRefreshing = false;
        refreshPromise = null;

        if (res.code === "UASI0000") {
          return true;
        }

        if (res.code === "UASI0011") {
          localStorage.setItem("token", "Bearer " + res.data.access_token);
          localStorage.setItem("refresh_token", "Bearer " + res.data.refresh_token);
          CommonUtil.setCookie("token", "Bearer " + res.data.access_token, 1);
          CommonUtil.setCookie("refresh_token", "Bearer " + res.data.refresh_token, 1);
          const decoded = jwtDecode(res.data.access_token);
          localStorage.setItem("USER", JSON.stringify(decoded));
          return true;
        }

        if (res.code !== "UASI0011" && res.code !== "UASI0000" ) {
          window.location = "/";
        }

        return false;

      } catch (e) {
        isRefreshing = false;
        refreshPromise = null;
        console.log("error", e);
        return e;
      }
    })();

    return refreshPromise;

  } else {
    window.location = "/";
  }
};

